import React, { Component } from 'react';
import './feebox-ng.css';

export class FeeBoxXU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: props.price,
      categoryCount: props.categoryCount,
      fee: 0,
      feeStepConst:1,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.price !== this.state.price || nextProps.categorieCount !== this.state.categoryCount || nextState !== this.state) {
      return true;
    }
    else {
      return false;
    }
  }

  componentWillReceiveProps(props) {
    var self = this;
    this.setState({
      price: props.price,
      feeStepConst: props.feeStepConst,
      categoryCount: props.categoryCount
    }, function () {
      if (self.props.type === "software") {
        self.computeSoftwareFee();
      }
      else {
        self.computeServiceFee();
      }

    });
  }

  computeSoftwareFee() {
    var catCount = this.state.categoryCount;
    var price;

    if (this.state.price !== undefined) {
      price = this.state.price;
    }
    else {
      price = 0;
    }

    var fee;

    if (catCount !== 0) {

      if (price >= 0 && price <= 30) {
        fee = catCount * 10;
      }

      if (price >30 && price <=150) {
        fee = catCount * 30;
      }
      if (price > 150 && price <= 500) {
        fee = catCount * 100;
      }

      if (price > 500 && price <= Number.MAX_SAFE_INTEGER) {
        fee = catCount * 300;
      }
    }
    else {
      fee = 0;
    }
    this.setState({ fee: fee });
    localStorage.setItem('fee', fee);
    return fee;
  }

  computeServiceFee() {
    var catCount = this.state.categoryCount;
    var feeStepConst = this.state.feeStepConst;
    var price = this.state.price;
    var feeStep, fee;

    if (catCount !== 0 &&  price !== 0 ) {
      if (catCount % 3 !== 0) {
        feeStep = Math.floor(catCount / 3) + 1;
      }
      else {
        feeStep = Math.floor(catCount / 3);
      }
      fee = feeStep * feeStepConst;
    }
    else {
      fee = 0;
    }
    this.setState({ fee: fee });
    localStorage.setItem('fee', fee);
    return fee;
  }

  render() {
    return (
      <div className="FeeBoxNG" id="IdFeeBoxNG">
        <h3>Gebühr fürs Einstellen</h3>
        <div>
          <strong>Summe:</strong>
          {this.state.fee || 0} EUR
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/feebox-xu.js